module.exports = __webpack_public_path__ + "img/drug-cat.96f7531c.png";